export default __webpack_public_path__ + "static/media/logo_final.c2a298dd.cdr";